import {createSlice, current} from "@reduxjs/toolkit";
import {Device} from "../../models/Device";
/**
 * Device Slice
 * - Takes in device objects in db format
 * - Stores device obects in frontend format
 * - stores data as dict of dict:
 * data: { deviceId1: {Device obj 1},
 *         deviceId2: {Device obj 2},
 *         ...
 *       }
 *
 */
const initialState = {
  loading: false,
  data: {},

  error: "",
};

const deviceSlice = createSlice({
  name: "device",
  initialState,

  reducers: {
    addDevice: (state, action) => {
      let newDevice = {
        deviceId: action.payload.deviceId,
        roomId: action.payload.roomId,
        status: null,
      };
      state.data[action.payload.deviceId] = newDevice;
    },
    updateDevice: (state, action) => {
      let did = action.payload.device_id;
      if (!state.data[did]) return;
      let copy = {...current(state.data)};
      let updateDevice = {...copy[did]};
      updateDevice.status = action.payload.status;
      updateDevice.updateTime = action.payload.update_time;
      copy[did] = updateDevice;
      state.data = copy;
    },
    deleteDevice: (state, action) => {
      const key = action.payload.deviceId;
      delete state.data[key];
    },

    setDevice: (state, action) => {
      let deviceList = action.payload;
      let deviceDict = {};
      for (let device of deviceList) {
        device = JSON.parse(JSON.stringify(new Device(device)));
        deviceDict[device.deviceId] = device;
      }
      state.data = deviceDict;
    },
  },
});

export const {addDevice, updateDevice, deleteDevice, setDevice} =
  deviceSlice.actions;

export default deviceSlice.reducer;
